/* eslint no-unused-vars: 0 */

import React from "react"

class AdminSearchError extends React.PureComponent {
  constructor(props) {
    super(props);
    this.reloadApplication = this.reloadApplication.bind(this);
  }

  reloadApplication() {
    window.location.href = "/admin/site_search";
  }

  render() {
    var display;
    if (this.props.display === true) {
      display = (
        <div className="admin--modal">
          <div className="admin--modal--content">
            <div className="admin--modal-title">
              <h1>Error</h1>
            </div>
            <div className="admin--modal-body">
              <p>
                Sorry, an error has occured. If this problem persists, please
                contact: <strong>webdevteam@cef.co.uk</strong>
              </p>
            </div>
            <a className="btn action" onClick={this.reloadApplication}>
              Restart
            </a>
          </div>
        </div>
      );
    } else {
      display = null;
    }
    return <div>{display}</div>;
  }
}

export default AdminSearchError;
